import InputSlider from '@/components/sections/builder/settings/input-slider';
import InputTab from '@/components/sections/builder/settings/input-tab';
import SchemeSetting from '@/components/sections/builder/settings/scheme-setting';
import { ThemeCollectionType, useBuilderStore } from '@/stores/builder';
import { shallow } from 'zustand/shallow';

export const DEFAULT_THEME_COLLECTION = {
  style: 'standard',
  imagePadding: 0,
  textAlignment: 'left',
  borderThickness: 0,
  borderOpacity: 0,
  borderCornerRadius: 0,
  shadowOpacity: 0,
  shadowHorizontalOffset: 0,
  sahdowVerticalOffset: 0,
  shadowBlur: 0,
  limitCharacters: 50,
  fontSize: 100,
};

export default function ThemeCollectionSetting() {
  const builder = useBuilderStore(
    (state) => ({
      theme: state.theme,
      setTheme: state.setTheme,
    }),
    shallow
  );

  const collection: ThemeCollectionType = builder.theme?.collection || DEFAULT_THEME_COLLECTION;

  const setStyle = (newCollection: Partial<ThemeCollectionType>) => {
    builder.setTheme({
      collection: { ...collection, ...newCollection },
    });
  };

  return (
    <div>
      <h3 className='mb-2 mt-4 font-bold'>Style</h3>
      <InputTab
        grid={2}
        defaultValue={collection.style || DEFAULT_THEME_COLLECTION.style}
        options={[
          { label: 'Standard', value: 'standard' },
          { label: 'Card', value: 'card' },
        ]}
        onChange={(val) => setStyle({ style: val })}
      />
      <InputSlider
        label='Image Padding'
        value={collection.imagePadding}
        max={12}
        min={0}
        onChange={(val) => setStyle({ imagePadding: val })}
        rightContent={<div>px</div>}
      />
      <div className='mb-1 mt-4'>Text Alignment</div>
      <InputTab
        defaultValue={collection.textAlignment || DEFAULT_THEME_COLLECTION.textAlignment}
        options={[
          { label: 'Left', value: 'left' },
          { label: 'Center', value: 'center' },
          { label: 'Right', value: 'right' },
        ]}
        onChange={(val) => setStyle({ textAlignment: val })}
      />
      <InputSlider
        label='Font size scale'
        value={collection.fontSize || 100}
        max={200}
        min={100}
        step={10}
        onChange={(val) =>
          setStyle({
            fontSize: val,
          })
        }
      />
      <div className='mb-2 mt-4'>Color scheme</div>
      <SchemeSetting
        value={collection.colorScheme}
        onChange={(theme) => setStyle({ colorScheme: theme })}
      />
      <div className='mt-1 text-xs'>
        To edit all your theme&apos;s colors, go to your color theme settings.
      </div>
      <h3 className='mb-2 mt-4 font-bold'>Border</h3>
      <InputSlider
        label='Thickness'
        value={collection.borderThickness}
        max={12}
        min={0}
        onChange={(val) => setStyle({ borderThickness: val })}
        rightContent={<div>px</div>}
      />
      <InputSlider
        label='Opacity'
        value={collection.borderOpacity}
        max={100}
        min={0}
        onChange={(val) => setStyle({ borderOpacity: val })}
        rightContent={<div>%</div>}
      />
      <InputSlider
        label='Corner Radius'
        value={collection.borderCornerRadius}
        max={40}
        min={0}
        onChange={(val) => setStyle({ borderCornerRadius: val })}
        rightContent={<div>px</div>}
      />
      <h3 className='mb-2 mt-4 font-bold'>Shadow</h3>
      <p className='text-sm'>Affects areas with multiple columns or rows.</p>
      <InputSlider
        label='Opacity'
        value={collection.shadowOpacity}
        max={100}
        min={0}
        onChange={(val) => setStyle({ shadowOpacity: val })}
        rightContent={<div>%</div>}
      />
      <InputSlider
        label='Horizontal Offset'
        value={collection.shadowHorizontalOffset}
        max={12}
        min={-12}
        onChange={(val) => setStyle({ shadowHorizontalOffset: val })}
        rightContent={<div>px</div>}
      />
      <InputSlider
        label='Vertical Offset'
        value={collection.sahdowVerticalOffset}
        max={12}
        min={-12}
        onChange={(val) => setStyle({ sahdowVerticalOffset: val })}
        rightContent={<div>px</div>}
      />
      <InputSlider
        label='Shadow Blur'
        value={collection.shadowBlur}
        max={20}
        min={0}
        onChange={(val) => setStyle({ shadowBlur: val })}
        rightContent={<div>px</div>}
      />
      <InputSlider
        label='Limit Charecters'
        value={collection.limitCharacters || 50}
        max={200}
        min={50}
        onChange={(val) => setStyle({ limitCharacters: val })}
      />
    </div>
  );
}
